import { JOBS_SITE_URL } from '@/constants/jobsSite';
import { LOGIN_PATH } from '@/constants/login';
import { SIGNUP_PATH } from '@/constants/signup';
import { CAREERS_PATH, CAREERS_ROUTES, NEXT_PARAM } from '../constants';

// Sign-in and sign-up live in the shared /auth/* pages, not in the candidate area; a candidate's are
// on the listings' own domain when it has one. A candidate `next` is what opens their candidate tab,
// and callers leave with a full page load.
// On the listings' own domain only candidates sign in and they land on their dashboard anyway, so
// the address carries `next` only for another page (/auth/login, not ?next=/careers/dashboard).
// Without one `next` is what opens the candidate tab, so it is always there. Its slashes stay as
// they are (?next=/careers/jobs/x rather than %2F…): they are allowed in a query and read the same.
const withCandidateNext = (path: string, next?: string | null): string => {
  const target = next || CAREERS_ROUTES.dashboard;
  if (JOBS_SITE_URL && target === CAREERS_ROUTES.dashboard) return `${JOBS_SITE_URL}${path}`;
  return `${JOBS_SITE_URL}${path}?${NEXT_PARAM}=${encodeURIComponent(target).replace(/%2F/gi, '/')}`;
};

/** The shared login page on its candidate tab, coming back to `next` once signed in. */
export const candidateLoginPath = (next?: string | null): string => withCandidateNext(LOGIN_PATH, next);

/** The shared sign-up page on its candidate tab, going on to `next` once the account is open. */
export const candidateSignupPath = (next?: string | null): string => withCandidateNext(SIGNUP_PATH, next);

/** A page of the candidate area, or null — so a redirect target can never send anyone off-site. */
export const safeCareersPath = (value: string | null | undefined): string | null =>
  value && value.startsWith(`${CAREERS_PATH}/`) && !value.includes('//') ? value : null;

/** Where to go after signing in, from the `next` query parameter. */
export const safeNextPath = (search: string): string | null =>
  safeCareersPath(new URLSearchParams(search).get(NEXT_PARAM));
